// extracted by mini-css-extract-plugin
export default {"internalServer":"ErrorBoundary_internalServer__IrwTo","description":"ErrorBoundary_description__CBPEh"};